//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Vyp.WebControls.VypraveniSettingsForm.ts                 </Name>
//    <Description> Uživatelské nastavení SPI.                              </Description>
//    <Author>      JSindelka                                                      </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2018                            </Copyright>
//    <Created>     2018-05-22                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.AppSettings {
    /**
     * Cesta k objetu nastavení zásilky v GStore.
     * 
     * @author  JSindelka
     * @date    30.04.2019
     */
    export const SettingsPath = "Global.Pod.AppSettings.PodElPodaniSettings"

    /**
     * Vrátí hodnoty uživatelského nastavení zásilky.
     *
     * @author  JSindelka
     * @date    30.04.2019
     *  
     * @returns {Gordic.Pod.Interface.GPodElPodaniSettingsDto} Hodnoty uživatelského nastavení zásilky.
     */
    export function GetPodSettings(): Gordic.Pod.Interface.GPodElPodaniSettingsDto {
        const settings: Gordic.Pod.Interface.GPodElPodaniSettingsDto | null | undefined = (window as any).gstor.get(SettingsPath, true);
        if (settings) {
            return settings;
        } else {
            return {  

            };
        }
    }

    /**
     * Nastaví hodnoty uživatelského nastavení zásilky.
     *  
     * @author  JSindelka
     * @date    30.04.2019
     *  
     * @param {Gordic.Pod.Interface.GPodElPodaniSettingsDto | null} value Hodnoty uživatelského nastavení zásilky.
     */
    export function SetSpiSettings(value: Gordic.Pod.Interface.GPodElPodaniSettingsDto | null): void {
        (window as any).gstor.set(SettingsPath, value);
    }

    /**
     * Formulář uživatelského nastavení vypravení.
     *
     * @author  JSindelka
     * @date    30.04.2019
     */
    export function PodElPodaniSettingsForm(): Forms.Form {
        const formName = "PodElPodaniSettingsForm";
        let modelProperty: (keyof Gordic.Pod.Interface.GPodElPodaniSettingsDto) | undefined;

        const form = new Gordic.Forms.Form({
            name: formName,
            tabOptions: {
                title: "jres:23900081", //RC 23900081 : El. podání
                opened: false
            }
        } as any);

        
        //form.addSection("jres:23900082") //RC 23900082 : Povinné položky
        //form.addRow().addField("gcheck", "", { name: "VecPovinne", model: SettingsPath + "." + (modelProperty = "VecPovinne"), label: "jres:23900083" }); //RC 23900083 : Věc
        //form.addRow().addField("gcheck", "", { name: "PscPovinne", model: SettingsPath + "." + (modelProperty = "PscPovinne"), label: "jres:23900084" }); //RC 23900084 : PSČ
        //form.addRow().addField("gcheck", "", { name: "OdesilatelPovinne", model: SettingsPath + "." + (modelProperty = "OdesilatelPovinne"), label: "jres:23900018" }); //RC 23900018 : Odesilatel
        form.addSection("jres:23900086") //RC 23900086 : Ostatní
        form.addRow("jres:31950238").addField("gstringbox",{ name: "PreplneniVec", model: SettingsPath + "." + (modelProperty = "PreplneniVec") }); //RC 31950238 : Nastavení předplnění položky Věc
        form.addRow().addField("gcheck", "", { name: "ProhoditPlneniVecAPoznamka", model: SettingsPath + "." + (modelProperty = "ProhoditPlneniVecAPoznamka"), label: "jres:31950239" }); //RC 31950239 : Prohodit plnění položky věc a poznámka k doručení
        form.addRow().addField("gcheck", "", { name: "NevalidovatPDF", model: SettingsPath + "." + (modelProperty = "NevalidovatPDF"), label: "jres:23900087" }); //RC 23900087 : Nevalidovat PDF
        form.addRow().addField("gcheck", "", { name: "PodaniMailJeObsahZpravy", model: SettingsPath + "." + (modelProperty = "PodaniMailJeObsahZpravy"), label: "jres:23900088" }); //RC 23900088 : Standardně zatrhnout u el. podání e-mailem, že podání je obsah zprávy 
        form.addRow().addField("gcheck", "", { name: "PodaniDZJeObsahZpravy", model: SettingsPath + "." + (modelProperty = "PodaniDZJeObsahZpravy"), label: "jres:23900089" }); //RC 23900089 : Standardně zatrhnout u el. podání z datové zprávy, že podání je obsah zprávy
        form.addRow().addField("gcheck", "", { name: "NeplnitMailPotvrzeniStandardTextem", model: SettingsPath + "." + (modelProperty = "NeplnitMailPotvrzeniStandardTextem"), label: "jres:23900090" }); //RC 23900090 : Neplnit tělo mailu potvrzením přijmu na el. podání standardním textem
        form.addRow().addField("gcheck", "", { name: "PoElPodaniZobrazitDetailDokumentu", model: SettingsPath + "." + (modelProperty = "PoElPodaniZobrazitDetailDokumentu"), label: "jres:23900091" }); //RC 23900091 : Po dokončení zobrazit detail dokumentu
        form.addRow().addField("gcheck", "", { name: "PrenestDoVeciPredmetZpravy", model: SettingsPath + "." + (modelProperty = "PrenestDoVeciPredmetZpravy"), label: "jres:23900092" }); //RC 23900092 : Přenést do položky věc předmět zprávy
        form.addRow().addField("gcheck", "", { name: "PrenestDoVeciPodrobnePredmetZpravy", model: SettingsPath + "." + (modelProperty = "PrenestDoVeciPodrobnePredmetZpravy"), label: "jres:23900093" }); //RC 23900093 : Přenést do položky věc podrobně předmět zprávy
        form.addRow("jres:23900094").addField("gnumberbox", "w-2", { name: "PocetDniKeZpracovani", model: SettingsPath + "." + (modelProperty = "PocetDniKeZpracovani")  }); //RC 23900094 : Počet dní, do kdy má být zpracováno
        form.addRow("jres:23900095").addField("gnumberbox", "w-2", { name: "PocetHodinPredZpracovanim", model: SettingsPath + "." + (modelProperty = "PocetHodinPredZpracovanim") }); //RC 23900095 : Počet hod. před zpracováním
        form.addRow("jres:31950078").addField("gselectbox", Gordic.Prefabs.Select.sslstyp(), { name: "TypPisemnosti", model: SettingsPath + "." + (modelProperty = "IxsTypDok") + ' = value.ixs_typ' });

        var prefab = Gordic.Wfl.Prefabs.GPocetListu(

            
            Gordic.Wfl.WebClient.GetGWflDBParams(), // nejde zatím číst z mainu protože se používá i v hybridu
            {
                model: SettingsPath + ".PocetListuStran.Listu",
                validators: []
            },
            {
                model: SettingsPath + ".PocetListuStran.Stran"

            },
            {
                model: SettingsPath + ".PocetListuStran.Priloh",
                validators:[]

            },
            {
                model: SettingsPath + ".PocetListuStran.ListuPriloh"

            },
            {
                model: SettingsPath + ".PocetListuStran.Kopii"

            },
            undefined,
            undefined,
            undefined,
            true
        );

        form.addPrefab(prefab);

        form.addRow().addField("gcheck", "", { name: "EvidovatElPodani", model: SettingsPath + "." + (modelProperty = "EvidovatElPodani"), label: "jres:31950366" }); //RC 31950366 : Přednastavit zatržítko evidovat
        form.addRow().addField("gcheck", "", { name: "PouzivatHistoriiVPolicuVec", model: SettingsPath + "." + (modelProperty = "PouzivatHistoriiVPolicuVec"), label: "jres:31950241" }); //RC 31950241 : Používat historii v položce Věc
        form.addRow().addField("gcheck", "", { name: "OverPodpisyRucne", model: SettingsPath + "." + (modelProperty = "OverPodpisyRucne"), label: "jres:31950242" }); //RC 31950242 : Ověřovat podpisy ručně na tlačítko Ověřit vše (ne automaticky)
        form.addRow().addField("gcheck", "", { name: "DialogZnackaOdes", model: SettingsPath + "." + (modelProperty = "DialogZnackaOdes"), label: "jres:31950243" }); //RC 31950243 : Zobrazovat informační okno o dokumentech se stejnou značkou odesílatele
        form.addRow().addField("gcheck", "", { name: "ZastavitElPodaniPriRozboru", model: SettingsPath + "." + (modelProperty = "ZastavitElPodaniPriRozboru"), label: "jres:31950244" }); //RC 31950244 : Zastavit zpracování el. podání před rozborem
        form.addRow().addField("gcheck", "", { name: "VecDleTypDok", model: SettingsPath + "." + (modelProperty = "VecDleTypDok"), label: "jres:31950245" }); //RC 31950245 : Plnit Věc dle typu dokumentu
        form.addRow().addField("gcheck", "", {
            name: "AsynchronOvereni",
            model: SettingsPath + "." + (modelProperty = "AsynchronOvereni"),
            label: "jres:31950388", //RC 31950388 : Použít asynchronní (rychlejší) ověření podpisů
            initialValue: true
        }); //RC 31950245 : Plnit Věc dle typu dokumentu



        return form;
    }
}